import { FC } from 'react';

import { DatePicker, DatePickerProps, FormInstance } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { DATE_FORMAT } from 'constants/commons';

dayjs.extend(utc);
dayjs.extend(timezone);

interface CustomDatePickerProps extends Omit<DatePickerProps, 'name' | 'form'> {
  name: string | string[];
  form: FormInstance;
}

const CustomDatePicker: FC<CustomDatePickerProps> = ({
  name,
  form,
  ...props
}) => {
  const handleChange = (date: Dayjs | null) => {
    if (date) {
      form.setFieldValue(name, date.tz(dayjs.tz.guess()).format());
    } else {
      form.setFieldValue(name, '');
    }
  };

  const disabledDate = (current: Dayjs): boolean =>
    current && current < dayjs().endOf('day');

  return (
    <DatePicker
      {...props}
      disabledDate={disabledDate}
      format={DATE_FORMAT}
      placeholder={DATE_FORMAT}
      value={form.getFieldValue(name) ? dayjs(form.getFieldValue(name)) : null}
      onChange={handleChange}
    />
  );
};

export default CustomDatePicker;
